import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CardHeader from './CardHeader';

import './Card.css';

const Card = ({ classNames, className, children }) => (
  <section className={classnames('Card', classNames, className)}>{children}</section>
);

Card.propTypes = {
  /** classNames property is deprecated, please use className instead. */
  classNames: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

Card.defaultProps = {
  classNames: '',
  className: '',
  children: null,
};

Card.Header = CardHeader;

export default Card;



// WEBPACK FOOTER //
// ../ui-components/components/Card/Card.jsx